// extracted by mini-css-extract-plugin
module.exports = {"root":"FlowStatsPage_root__3JvDg","title":"FlowStatsPage_title__2lgk9","title_name":"FlowStatsPage_title_name__2hXPp","stats":"FlowStatsPage_stats__3By1c"};